import answererRepository from '@/repositories/answerer/answerer.repository'

class AnswerService {
  async checkAnswerInfo (params) {
    const data = await answererRepository.checkAnswerInfo(params);
    return data || [];
  }
  async checkStatus (params) {
    const data = await answererRepository.checkStatus(params);
    return data || [];
  }
  async callSaveAnswerInfo (params) {
    const data = await answererRepository.callSaveAnswerInfo(params);
    return data || [];
  }
  async findAnswerDetailInfo (params, userType) {
    const data = await answererRepository.findAnswerDetailInfo(params, userType);
    return data || [];
  }
  async findAnswerDetailHistoryInfo (params, versionNo, userType) {
    const data = await answererRepository.findAnswerDetailHistoryInfo(params, versionNo, userType);
    return data || [];
  }
}

module.exports = new AnswerService();



// WEBPACK FOOTER //
// ./src/services/answerer/answerer.service.js